import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom'; // Added useNavigate; Step 30: useLocation for the current-page pill
import { signOut } from 'firebase/auth'; // Added signOut import
import { auth } from '../utils/firebase'; // Ensure your Firebase auth is properly imported
import { useDispatch } from 'react-redux';
import { logoutClients } from '../Redux/slices/clientSlice';
import { logoutUser } from '../Redux/slices/userSlice';

// Step 30 (owner, 2026-09-04): the three top-bar buttons are fully round
// pills — light lavender with dark purple bold text, and the CURRENT page's
// pill filled purple with white text. Colours sampled from the owner's
// picture. Inline styles, so no page stylesheet can dim them. The look is
// shared by every page that renders this bar.
const PILL_LIGHT = '#E8E6F2';
const PILL_TEXT = '#34205C';
const PILL_ACTIVE = '#3C1CC0';
const pillStyle = (active) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    height: 28,
    minWidth: 115,
    padding: '0 22px',
    border: 'none',
    borderRadius: 9999,
    background: active ? PILL_ACTIVE : PILL_LIGHT,
    color: active ? '#FFFFFF' : PILL_TEXT,
    fontSize: 15,
    fontWeight: 700,
    lineHeight: '28px',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    boxShadow: 'none',
    textDecoration: 'none',
});

const NavBar = () => {
    const navigate = useNavigate(); // Added navigate hook for navigation
    const dispatch = useDispatch();
    const location = useLocation();
    const pathname = location?.pathname || '';
    // The pill whose link matches the current path is the purple one.
    const isCurrent = (to) => pathname === to || pathname.startsWith(`${to}/`);

    const logouthandle = async (e) => {
        e.preventDefault();
        // Check if 'user_id' exists in localStorage
        // if (localStorage.getItem('user_id')) {
        //     localStorage.removeItem('user_id'); // Remove 'user_id' from localStorage
        // }
        // if (localStorage.getItem('oldprofile')) {
        //     localStorage.removeItem('oldprofile'); 
        // }
        // localStorage.clear();
        if (localStorage.getItem('user_id')) {
            localStorage.removeItem('user_id');
        }
        if (localStorage.getItem('oldprofile')) {
            localStorage.removeItem('oldprofile');
        }
        await signOut(auth); // Await added to ensure signOut is complete
        dispatch(logoutClients());
        dispatch(logoutUser())
        navigate("/"); // Navigate to home after sign out
    };

   
    return (
        <div
            className="fixed top-0 left-0 w-full z-50 flex flex-row gap-2 h-12"
            style={{
                background: "linear-gradient(to right,#CB34F3 0%,#5A39FD 33%,#0085FF 68%,#00FF62 100%)"
            }}
        >
            <div className="header-btns-div text-black flex"> {/* Added flex to align buttons */}
                <Link to="/proposal-dashboard">
                <h2 className=" lg:ml-[-1rem]  py-2 text-3xl text-white font-bold">Grant<span className='text-white font-bold'>AI</span>de</h2>
                </Link>
                <div className=" header-btns-left">

                    <Link to="/proposal-dashboard" className="mr-4">
                        <button
                            type="button"
                            className="font-sans"
                            style={pillStyle(isCurrent('/proposal-dashboard'))}
                            aria-current={isCurrent('/proposal-dashboard') ? 'page' : undefined}
                            >
                                Dashboard
                            </button>
                    </Link>
                    <Link to="/grant-database">
                        <button
                            type="button"
                            className="font-sans"
                            style={pillStyle(isCurrent('/grant-database'))}
                            aria-current={isCurrent('/grant-database') ? 'page' : undefined}
                            >
                              GrantDB
                            </button>
                    </Link>
                </div>

                <div className='header-btns-right'>
                    <button
                        type="button"
                        className="font-sans"
                        style={pillStyle(false)}
                        onClick={logouthandle}
                    >
                        Sign Out
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NavBar;